import React, {useEffect, useState} from "react";
import DescriptionIcon from "@mui/icons-material/Description";
import InputsPreviewAntecipacao from "./InputsPreviewAntecipacao";
import {Button, Form} from "react-bootstrap";
import Popup from "../../../../component/Popup/Popup";
import SimulationModal from "./SimulationModal";

export default function PopupPreviewAntecipacao({taxaAdmin, taxaAntecipacao}) {

    // Modal control
    const [lgShow, setLgShow] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(false);

    // Modal requestBody
    const icon = <DescriptionIcon fontSize="large" id="icon-svg"/>
    const title = 'Simular antecipação'
    const iconSpan = (
        <>
            {icon}
            <h3>{title}</h3>
        </>
    );

    const [data, setData] = useState({})
    const [openPreview, setOpenPreview] = useState(false);

    // Variable to do preview
    const [requestBody, setRequestBody] = useState({
        taxaAdmin,
        taxaAntecipacao
    })

    useEffect(() => {
        setRequestBody(prevData => {
            return {...prevData, taxaAdmin, taxaAntecipacao}
        })
    }, [taxaAdmin, taxaAntecipacao])

    const handleSubmit = (e) => {
        e.preventDefault()
        setOpenPreview(true)
    }

    return <>
        <Popup
            backdrop="static"
            title={title}
            iconSpan={iconSpan}
            buttonText={title}
            lgShow={lgShow}
            setLgShow={setLgShow}
            buttonClass={"btn btn-primary button-show"}
        >
            <div>
                <Form onSubmit={handleSubmit} className="form-inputs">
                    <InputsPreviewAntecipacao setRequestBody={setRequestBody}/>

                    {error}

                    <Button
                        className={"btn btn-primary"}
                        type={'submit'}
                    >
                        {isLoading ? (
                            <>
                                    <span
                                        className="spinner-border spinner-border-sm"
                                        role="status"
                                        aria-hidden="true"
                                    ></span>
                                Aguarde...
                            </>
                        ) : ( 
                            title
                        )}
                    </Button>
                </Form>
                <SimulationModal
                    openPreview={openPreview} setOpenPreview={setOpenPreview}
                    requestBody={requestBody} error={error} setError={setError}
                />
            </div>
        </Popup>
    </>
}